const { info } = require("sass");

// burger menu
var burger = document.querySelector(".burger");
var menu = document.querySelector(".menu");
var nav = document.querySelector(".menu-nav");

var toggleMenu = function toggleMenu(event) {
  if (!event.target.classList.contains("menu")) {
    menu.classList.toggle("is-active");
  }
};

var closeMenu = function closeMenu(event) {
  if (!event.target.classList.contains("menu")) {
    menu.classList.remove("is-active");
    burger.classList.toggle("is-active");
  }
};

var toggleMenu = function toggleMenu() {
  menu.classList.toggle("is-active");
  burger.classList.toggle("is-active");
};

burger.addEventListener("click", toggleMenu);
nav.addEventListener("click", closeMenu);

// swiper
import Swiper, { Navigation, Pagination } from "swiper";

Swiper.use([Navigation, Pagination]);

const swiper = new Swiper(".swiper-container", {
  loop: true,
  pagination: {
    el: ".swiper-pagination",
  },
  navigation: {
    nextEl: ".button-slider-next",
    prevEl: ".button-slider-prev",
  },
});

//curseur
var cursor = document.getElementById("cursor");

document.addEventListener("mousemove", moveCursor);

function moveCursor(e) {
  var x = e.clientX;
  var y = e.clientY;
  cursor.style.left = `${x}px`;
  cursor.style.top = `${y}px`;
}

var text = Array.from(document.querySelectorAll("a"));
text.forEach((text) => {
  text.addEventListener("mousemove", function () {
    cursor.classList.add("cursor-hover");
  });
  text.addEventListener("mouseleave", function () {
    cursor.classList.remove("cursor-hover");
  });
});

//vidéo
const video = document.getElementById("video");
const circlePlayButton = document.getElementById("button-video");

function togglePlay() {
  if (video.paused || video.ended) {
    video.play();
  } else {
    video.pause();
  }
}

circlePlayButton.addEventListener("click", togglePlay);
video.addEventListener("playing", function () {
  circlePlayButton.style.opacity = 0;
});
video.addEventListener("pause", function () {
  circlePlayButton.style.opacity = 1;
});

//animations scroll
import gsap from "gsap";

gsap.to(".beer-decoration-blond", { rotation: 90, scale: 1, duration: 1 });

import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

gsap.to(".beer-decoration-blond", {
  scrollTrigger: {
    trigger: ".trigger-blond",
    scrub: 1,
    end: "top+=330",
    // markers: true,
  },
  rotation: 90,
  scale: 1,
  duration: 1,
});

gsap.to(".beer-decoration-dark", { rotation: -90, scale: 1, duration: 1 });

gsap.to(".beer-decoration-dark", {
  scrollTrigger: {
    trigger: ".trigger-dark",
    scrub: 1,
    end: "top+=330",
    // markers: true,
  },
  rotation: -90,
  scale: 1,
  duration: 1,
});

gsap.to(".beer-decoration-ipa", { rotation: 90, scale: 1, duration: 1 });

gsap.to(".beer-decoration-ipa", {
  scrollTrigger: {
    trigger: ".trigger-ipa",
    scrub: 1,
    end: "top+=330",
    // markers: true,
  },
  rotation: 90,
  scale: 1,
  duration: 1,
});

//infos ingrédients
var buttonBlondWater = document.getElementById("button-blond-water");
var cardBlondWater = document.getElementById("card-blond-water");
var buttonChevron = document.getElementById("chevron-blond-water");

var toggleBlondWater = function toggleBlondWater(event) {
  if (!event.target.classList.contains("card-blond-water")) {
    cardBlondWater.classList.toggle("is-active");
  }
};

var closeBlondWater = function closeBlondWater(event) {
  if (!event.target.classList.contains("card-blond-water")) {
    cardBlondWater.classList.remove("is-active");
  }
};

var toggleBlondWater = function toggleBlondWater() {
  cardBlondWater.classList.toggle("is-active");
  buttonBlondWater.classList.toggle("is-active");
};

buttonBlondWater.addEventListener("click", toggleBlondWater);
buttonChevron.addEventListener("click", closeBlondWater);

//infos magasins
var buttonEstavayer = document.getElementById("button-estavayer");
var cardEsatavyer = document.getElementById("card-estavayer");
var chevronEstavayer = document.getElementById("button-chevron-estavayer");

var toggleEstavayer = function toggleEstavayer(event) {
  if (!event.target.classList.contains("card-estavayer")) {
    cardEsatavyer.classList.toggle("is-active");
  }
};

var closeEstavayer = function closeCard(event) {
  if (!event.target.classList.contains("card-estavayer")) {
    cardEsatavyer.classList.remove("is-active");
  }
};

var toggleEstavayer = function toggleEstavayer() {
  cardEsatavyer.classList.toggle("is-active");
  buttonEstavayer.classList.toggle("is-active");
};

buttonEstavayer.addEventListener("click", toggleEstavayer);
chevronEstavayer.addEventListener("click", closeEstavayer);
